import { getItem, getSessionItem, removeSessionItem, setItem, setSessionItem } from '@/utils/storage'

/**
 * Ship customers live in the 'ship-users' database connection
 * Need to state explicitly for login and password change, because Auth0 falls back to 'test-users' as the default
 */
export const SHIP_USERS_CONNECTION = 'ship-users'

/**
 * AUTH0_LOGIN is saved into local storage for the unauthenticated
 * `/login` route decide whether to send the visitor to `/loginv2`.
 */
export const AUTH0_LOGIN_STORAGE_KEY = 'auth0-enabled'

export const setAuth0LoginEnabled = (enabled: boolean): void => setItem(AUTH0_LOGIN_STORAGE_KEY, enabled)

export const isAuth0LoginEnabled = (): boolean => getItem<boolean>(AUTH0_LOGIN_STORAGE_KEY) === true

const AUTH0_LOGIN_ATTEMPT_KEY = 'auth0LoginAttempt'

// Long enough to cover an Auth0 round trip that bounces straight back, short enough that a visitor
// who simply backed out of the Auth0 page is sent there again next time
const AUTH0_LOGIN_ATTEMPT_WINDOW_MS = 30_000

export const recordAuth0LoginAttempt = (): void => setSessionItem(AUTH0_LOGIN_ATTEMPT_KEY, Date.now())

export const clearAuth0LoginAttempt = (): void => removeSessionItem(AUTH0_LOGIN_ATTEMPT_KEY)

/**
 * Loop breaker. `/login` hands visitors to Auth0, and everything that fails after the Auth0
 * callback — a rejected token, an unreachable account endpoint — bounces them back to `/login`.
 * Auth0 still holds a session at that point, so redirecting again would go round forever. A recent
 * attempt means we already tried, so `/login` should fall through to the v1 form instead.
 */
export const hasRecentAuth0LoginAttempt = (): boolean => {
  const attemptedAt = getSessionItem<number>(AUTH0_LOGIN_ATTEMPT_KEY)

  return attemptedAt !== undefined && Date.now() - attemptedAt < AUTH0_LOGIN_ATTEMPT_WINDOW_MS
}
